/**
 * Real visitors (the script on the customer's site: sessions, heatmaps, funnels) are in the app for everyone, in
 * beta. Set VITE_REAL_USERS=false at build time to hide them again.
 */
export const REAL_USERS = import.meta.env.VITE_REAL_USERS !== 'false';

/**
 * Whether the public pages (landing, pricing, FAQ) talk about real visitors: on by default (decision of 26 October:
 * everything opens at launch). VITE_REAL_USERS_PUBLIC=false at build time keeps them out of the public pages
 * without touching the app.
 */
export const REAL_USERS_PUBLIC = REAL_USERS && import.meta.env.VITE_REAL_USERS_PUBLIC !== 'false';

/** First page of a project: its tests, the core of the product. */
export function projectHome(projectId: string): string {
  return `/p/${projectId}/synthetic`;
}
